import React, { useMemo, useState } from "react";
import { ChevronUpDownIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import ColumnSelectorDialog, { TableTypes } from "./ColumnSelectorDialog";
import useSelectedColumns from "@lib/hooks/use-selected-columns";
import { Button } from "@tracify/ui/button";
import { selectVariants } from "@tracify/ui/select";
import { cn } from "@lib/utils";
import ColumnsSelectorIcon from "@components/Layout/icons/columns-selector-icon";

type Props = {
  table: TableTypes;
  label?: string | React.ReactNode;
  dontShowColumn?: string | string[];
  variant?: "default" | "alternate";
  size?: "sm" | "default";
  labelBreakpoint?: "lg" | "xl";
};

export type ColumnSelectorProps = Props;

export const ColumnSelector: React.FC<ColumnSelectorProps> = ({
  table,
  label,
  dontShowColumn = [],
  variant = "default",
  size = "sm",
  labelBreakpoint = "lg",
}) => {
  const [open, setOpen] = useState(false);
  const { selectedColumnsOrder } = useSelectedColumns({
    table,
  });
  const availableSelectedColumn = useMemo(
    () => selectedColumnsOrder,
    [selectedColumnsOrder]
  );

  return (
    <>
      <ColumnSelectorDialog
        table={table}
        open={open}
        onClose={() => setOpen(false)}
        dontShowColumn={dontShowColumn}
      />
      <Button
        onClick={() => setOpen(true)}
        size={size === "sm" ? "icon-sm" : "icon-md"}
        variant="muted"
        className={cn(
          "flex",
          labelBreakpoint === "xl" ? "xl:hidden" : "lg:hidden"
        )}
      >
        <ColumnsSelectorIcon />
      </Button>
      <button
        onClick={() => setOpen(true)}
        className={cn(
          selectVariants({ variant, size }),
          "hidden w-fit",
          labelBreakpoint === "xl" ? "xl:flex" : "lg:flex"
        )}
      >
        <span className="block truncate font-semibold mr-2">
          {label ? label : `Columns`} (
          {
            availableSelectedColumn.filter((el) =>
              !Array.isArray(dontShowColumn)
                ? el.value !== dontShowColumn
                : !dontShowColumn.includes(el.value)
            )?.length
          }
          )
        </span>
        <span className="pointer-events-none">
          <ChevronUpDownIcon
            className="h-5 w-5 text-primary"
            aria-hidden="true"
          />
        </span>
      </button>
    </>
  );
};
export default ColumnSelector;
